import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { LocalizedDateTimeFormatKey } from '../types/localization-setting';
import { BaseLocalizedDateTimeRangeFormatPipe } from './base-localized-date-time-range-format.pipe';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'localizedDateRangeFormat',
  standalone: true,
})
export class LocalizedDateRangeFormatPipe
  extends BaseLocalizedDateTimeRangeFormatPipe
  implements PipeTransform
{
  protected readonly formatType: LocalizedDateTimeFormatKey = 'dateFormat';
}
